import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import {
  StyledList,
  StyledListItem,
  StyledSuggestionContainer,
  StyledSuggestionTitle,
  StyledSuggestionDescription,
  StyledSuggestionBody
} from './AiSuggestion.style';

const AiSuggestion = ({
  items, titleReplacements, header, body, showList = true
}) => (
  <StyledSuggestionContainer gap={4}>
    <Stack gap={2}>
      <Text
        fontWeight="medium"
        size="lg"
      >
        {header}
      </Text>
      {showList && (
        <StyledList>
          {items?.map(({ description: itemDescription, title: itemTitle }) => (
            <StyledListItem
              divider
              key={`${itemTitle}`}
            >
              <Stack>
                <StyledSuggestionTitle
                  fontWeight="medium"
                  size="sm"
                >
                  {titleReplacements?.[itemTitle] || itemTitle}
                </StyledSuggestionTitle>
                <StyledSuggestionDescription
                  fontWeight="regular"
                  size="sm"
                >
                  {itemDescription}
                </StyledSuggestionDescription>
              </Stack>
            </StyledListItem>
          ))}
        </StyledList>
      )}
      {body && (
        <StyledSuggestionBody
          fontWeight="regular"
          size="sm"
        >
          {body}
        </StyledSuggestionBody>
      )}
    </Stack>
  </StyledSuggestionContainer>
);

AiSuggestion.propTypes = {
  body: PropTypes.string,
  header: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string
    })
  ),
  titleReplacements: PropTypes.objectOf(PropTypes.string),
  showList: PropTypes.bool
};

AiSuggestion.displayName = 'AISuggestion';

export default AiSuggestion;
